<template>
  <div v-if="showLocationDetails" class="car-offer-list-item car-location-details">
<!--    show location details with ratings and picture etc in the item detail-->

    <!-- <div class="car-image-container">
      <vehicle-image class="car-vehicle__image--188x144" :img-width="'188'" :img-height="'144'" :offer="offer"></vehicle-image>
    </div> -->
    <div class="car-workshop-container">
      <span class="car-rating" v-if="offer.location.userRating"><span class="car-rating-average">{{ getRatingAverage() }}</span><ratings class="car-rating" :rating="offer.location.userRating"></ratings><span class="car-rating-count" v-if="offer.location.userRatingCount">({{offer.location.userRatingCount}})</span></span>
      <span class="car-workshop-name">{{offer.location.name}}</span>
      <span class="car-address" v-html="getLocationAddress()"></span>
      <span class="car-distance"><span>{{$t('offerSelection.item.distance')}}: </span><span>{{offer.location.distance}} km</span></span>
    </div>
    <div class="car-button-container">
      <div class="car-price"><span v-if="offer.actualGrossRate">{{offer.actualGrossRate | currency}}</span></div>
      <primary-btn
          class="car-btn-primary"
          @click="goNext"
        >{{$t('offerSelection.itemDetailBtn')}}
        </primary-btn>
    </div>
  </div>
  <div v-else class="car-offer-list-item car-no-location-details">
    <div class="car-price-container"><span v-if="offer.actualGrossRate" class="car-price">{{offer.actualGrossRate | currency}}</span></div>
    <div class="car-part-quality-container" :class="getQualityClass()">Inkl. Originalersatzteile</div>
    <div class="car-button-container">
      <primary-btn
          class="car-btn-primary"
          @click="goNext"
        >{{$t('offerSelection.itemDetailBtn')}}
        </primary-btn>
    </div>
  </div>
</template>

<script>
// import VehicleImage from '@/components/offerSelection/LocationImage';
import Ratings from '@/components/service-request/Ratings';
import { find } from 'lodash';
import { mapGetters } from 'vuex';
import PrimaryBtn from '@/components/PrimaryBtn';

export default {
  name: 'OfferListItem',
  props: {
    offer: {
      default: Object
    },
    showLocationDetails: {
      type: Boolean,
      default: true
    }
  },
  components: {
    PrimaryBtn,
    Ratings
    // VehicleImage
  },
  methods: {
    goNext() {
      this.$router.push({ name: 'offer', params: { key: this.offer.offerKey } })
    },
    getQualityClass() {
      if (this.partQuality && this.partQuality.type) {
        return `${this.partQuality.type.toLowerCase()}`;
      }
    },
    getRatingAverage: function () {
      return `${parseFloat(this.offer.location.userRating).toFixed(1)}`;
    },
    getLocationAddress: function () {
      return this.offer.location.address.replace(',', '<br>');
    }
  },
  computed: {
    ...mapGetters('offer', ['partQualityTypes', 'guilds']),
    partQuality() {
      return find(this.partQualityTypes, (type) => type.id === this.offer.partQualityTypeId) ||
      { name: this.$t('offerSelection.item.noQualityType') };
    },
    guild() {
      return find(this.guilds, (guild) => guild.id === parseInt(this.offer.location.guildMembership)) ||
        { name: this.$t('offerSelection.item.notGuildMember') };
    }
  }
}
</script>
